import { render, staticRenderFns } from "./JumpAppstore.vue?vue&type=template&id=1333c706&scoped=true&"
import script from "./JumpAppstore.vue?vue&type=script&lang=js&"
export * from "./JumpAppstore.vue?vue&type=script&lang=js&"
import style0 from "./JumpAppstore.vue?vue&type=style&index=0&id=1333c706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1333c706",
  null
  
)

export default component.exports